<template>
  <div class="cover-letter-container">
    <!-- Will be added again incase user raise a request
    <div class="cover-letter-header mb-3">
      <p class="section-title m-0 mb-3">{{$t('coverLetter.title')}} <span class="dropdown-btn" @click="showReadMore">{{$t('coverLetter.why')}}</span></p>
      <div v-show="readMore" class="readmore-section">
        <div class="inner">
          <p class="title m-0">
            {{$t('coverLetter.subTitle')}}
          </p>
          <p class="desc m-0">
            {{$t('coverLetter.desc')}}
          </p>
        </div>
      </div>
    </div> -->
    <div class="cover-letter-info">
      <p class="fs-20 font-weight-700 color-noble-blue-500 m-0 mb-2 pb-1">
        {{ $t('coverLetter.selectTitle') }}
      </p>
      <p class="desc" v-if="!hasExistingBanks">
        {{ $t('coverLetter.selectDesc', { name: buyer.importer }) }}
      </p>
    </div>

    <div class="cover-letter-main">
      <buyer-bank-addition
        v-if="!coverLetterLoading"
        :bank-list="bankList"
        :show-accordion="hasExistingBanks"
        :buyer="buyer"
        :selected-bank="selectedBank"
        @fetch-bank-list="$emit('fetch-bank-list')"
        @selected-bank-index="(i) => $emit('selected-bank-index', i)"
      />
      <loader v-else :height="105" />
    </div>

    <div
      v-if="error && (!bankList.length || selectedBank == -1)"
      class="cover-letter-error p-3 px-4 mt-3 d-flex align-items-center"
    >
      <b-icon-exclamation-circle-fill
        color="darkRed"
        scale="1.6"
        class="mr-4"
      />
      <p class="error-text m-0" v-if="!bankList.length">
        {{ $t('coverLetter.error.addBank') }}
      </p>
      <p class="error-text m-0" v-else-if="selectedBank == -1">
        {{ $t('coverLetter.error.selectBank') }}
      </p>
    </div>
  </div>
</template>

<script>
import BuyerBankAddition from '@/components/invoices/Add/Forms/funding/BuyerBankAddition'
import Loader from '@/components/common/Loader'

export default {
  props: {
    bankList: {
      type: Array,
      required: false,
      default: () => []
    },
    buyer: {
      type: Object,
      required: false,
      default: () => ({})
    },
    selectedBank: {
      type: [String, Number],
      required: false,
      default: ''
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    coverLetterLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      readMore: false
    }
  },
  methods: {
    showReadMore() {
      this.readMore = !this.readMore
    }
  },
  components: {
    BuyerBankAddition,
    Loader
  },
  computed: {
    hasExistingBanks() {
      return Boolean(this.bankList && this.bankList.length)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.cover-letter-container {
  font-family: $nunito;

  .section-title {
    font-size: 1.375rem;
    font-weight: 400;

    .dropdown-btn {
      font-size: 1.125rem;
      color: $primary;
      cursor: pointer;
    }
  }

  .readmore-section {
    border: 0.0625rem solid $table-border-color;
    border-radius: 0.25rem;
    padding: 1rem 1.25rem;

    .inner {
      border-left: 0.25rem solid $dc-blue;
      padding-left: 1.25rem;

      .desc {
        font-size: 0.875rem;
        font-weight: 400;
      }
    }
  }

  .cover-letter-info {
    .title {
      color: $noble-blue-500;
      margin-bottom: 12px;
      font-size: 1.25rem;
      font-weight: 700;
    }
    .desc {
      margin-bottom: 12px;
      font-size: 1rem;
      font-weight: 400;
    }
  }

  .cover-letter-error {
    background: $dc-error;
    border-radius: 0.25rem;

    .error-text {
      font-size: 0.875rem;
      font-weight: 700;
    }
  }
}
.fs-20 {
  font-size: 20px;
}
</style>
